import React from 'react';
import { Link } from 'react-router-dom';
import { pad } from '../content/site/paden';
import { siteTeksten } from '../content/site/teksten';

// De footer van de publieke pagina's. Stond als kopie in elke pagina, en daardoor
// liep hij uiteen: alleen Privacy, Subverwerkers en Voorwaarden linkten naar
// /subverwerkers, en op /demo stond nog "Offerte aanvragen" (19-10-2026).
// Stijl: .hh-footer in HomeHero.css.
//
// lang ('nl' | 'en') kiest teksten en links (content/site/teksten.js, paden.js).
// metOverOns: tweede kolom heet "Over" en begint met Over Ons (zoals op Over ons,
// Contact en Werken bij); anders "Support".
function PubliekeFooter({ lang = 'nl', metOverOns = false }) {
  const t = siteTeksten(lang).footer;
  const p = (sleutel) => pad(sleutel, lang);
  return (
    <footer className="hh-footer">
      <div className="hh-footer-inner">
        <div className="hh-footer-top">
          <div className="hh-footer-brand">
            <img src="/tw-logo-wit-02.svg" alt="TestWisely" className="hh-footer-logo" />
            <p className="hh-footer-tagline">{t.tagline}</p>
          </div>
          <div className="hh-footer-links">
            <div className="hh-footer-col">
              <h5>{t.platform}</h5>
              <Link to={p('hoeWerktHet')}>{t.hoeWerktHet}</Link>
              <Link to={p('kennisbank')}>{t.kennisbank}</Link>
              <Link to={p('demo')}>{t.demoAanvragen}</Link>
              <Link to={p('login')}>{t.inloggen}</Link>
            </div>
            <div className="hh-footer-col">
              <h5>{metOverOns ? t.over : t.support}</h5>
              {metOverOns && <Link to={p('overOns')}>{t.overOns}</Link>}
              <Link to={p('contact')}>{t.contact}</Link>
              <Link to={p('faq')}>{t.faq}</Link>
              <a href="mailto:info@testwisely.nl">info@testwisely.nl</a>
            </div>
            <div className="hh-footer-col">
              <h5>{t.werkenBij}</h5>
              <Link to={p('werkenBij')}>{t.vacatures}</Link>
              <Link to={p('openSollicitatie')}>{t.openSollicitatie}</Link>
            </div>
            <div className="hh-footer-col">
              <h5>{t.juridisch}</h5>
              <Link to={p('privacy')}>{t.privacy}</Link>
              <Link to={p('voorwaarden')}>{t.voorwaarden}</Link>
              <Link to={p('subverwerkers')}>{t.subverwerkers}</Link>
            </div>
          </div>
        </div>
        <div className="hh-footer-bottom">
          <span>&copy; {new Date().getFullYear()} TestWisely. {t.rechten}</span>
          <span>{t.gemaakt}</span>
        </div>
      </div>
    </footer>
  );
}

export default PubliekeFooter;
